import React from "react";

// Official-style "Get it on Google Play" badge button (SVG, self-contained).
export default function GooglePlayButton({ href = "#", className = "" }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-play-btn"
      className={`inline-flex items-center gap-3 rounded-xl border border-white/15 bg-black px-4 py-2.5 transition-transform hover:-translate-y-0.5 hover:border-white/30 ${className}`}
    >
      <svg width="24" height="26" viewBox="0 0 512 512" aria-hidden="true">
        <path fill="#00d0ff" d="M47 32 300 256 47 480c-9-5-15-15-15-27V59c0-12 6-22 15-27z" />
        <path fill="#00e676" d="M47 32c4-2 9-3 14-2l278 160-63 63L47 32z" />
        <path fill="#ff3d57" d="M355 205l63-36c14-8 14-30 0-38l-63-36-63 63 63 47z" transform="translate(-16 8)" />
        <path fill="#ffce00" d="M339 320 61 480c-5 1-10 0-14-2l229-221 63 63z" />
      </svg>
      <span className="text-start leading-tight">
        <span className="block text-[9px] uppercase tracking-wide text-white/70">Get it on</span>
        <span className="block text-base font-bold text-white">Google Play</span>
      </span>
    </a>
  );
}
